var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip"},[_c('span',[_vm._v("?")]),_c('p',{staticClass:"tooltiptext",domProps:{"innerHTML":_vm._s(_vm.tooltipText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }